import { bindDialog } from "../../../hooks/use-dialog-state/UseDialogState";
import { BindUICustomizationPresetEditorDialogReturn, UICustomizationPresetEditorDialogState } from "./UICustomizationPresetEditorDialog";

export function bindUICustomizationPresetEditorDialog(props: UICustomizationPresetEditorDialogState): BindUICustomizationPresetEditorDialogReturn {
    return bindDialog(props);
}
